import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyBLk-hdx6nQaYMLKJOn-q54qluQCxC1G9I",
    authDomain: "teams-clone-d4985.firebaseapp.com",
    projectId: "teams-clone-d4985",
    storageBucket: "teams-clone-d4985.appspot.com",
    messagingSenderId: "930216868525",
    appId: "1:930216868525:web:e32f2a264acdadf4faa424"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;